import { Box, Card, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { GoPrimitiveDot } from 'react-icons/go';
import { HiCheckCircle, HiPlay } from 'react-icons/hi';
import { getRecentExcelUploads, IExcelImportHistory } from 'wisestep-api';
import {
  WsColors,
  WsIconText,
  WsListingLoader,
  WsTitleColors,
  WsTitleHeader,
  WsTypoColors,
  timeSince,
} from 'wisestep-base';

import NoDataFoundCard from '../../../../components/noDataFoundCard';
interface IExcelProp {
  update?(): void;
}

const ExcelImportHistory = ({ update }: IExcelProp) => {
  const [loader, setLoader] = useState<boolean>(false);
  const [importHistory, setImportHistory] = useState<IExcelImportHistory[]>();

  const getStatus = (history: IExcelImportHistory) =>
    history.validationPending == 0 && history.status === 'COMPLETED' ? 'Completed' : 'In Process';

  const getTitle = (history: IExcelImportHistory) =>
    `${
      history.jobId
        ? `${history.jobCandidateMapping ? ' Mapped' : 'Submitted'} to Job  ${history.jobTitle}  ${
            history.jobCode
          } .`
        : 'Imported from Talent Pool.'
    }`;
  const fetchHistory = async () => {
    try {
      setLoader(true);
      const response = await getRecentExcelUploads();
      setLoader(false);
      setImportHistory(response.data);
    } catch (e) {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchHistory();
  }, [setLoader, update]);

  return (
    <Box p={2}>
      {importHistory && importHistory.length > 0 && !loader ? (
        importHistory?.map((history, index) => (
          <Card key={index} sx={{ m: 2, p: 1 }} variant="outlined">
            <Grid item xs={12} p={2} container spacing={2}>
              <Grid item container xs={12} columnGap={2}>
                <WsTitleHeader
                  title={`${history.fileName}`}
                  subtitle={getTitle(history)}
                  reversed={false}
                  color={WsTitleColors.BLACK}
                />
                <WsIconText
                  text={` ${timeSince(String(history.createdOn))} By ${history.createdByEmail}`}
                  icon={<GoPrimitiveDot />}
                />
                <WsIconText
                  text={getStatus(history)}
                  icon={
                    getStatus(history) == 'Completed' ? (
                      <HiCheckCircle color={WsColors.Green500} size={25} />
                    ) : (
                      <HiPlay color={WsColors.Yellow500} size={25} />
                    )
                  }
                  textColor={
                    getStatus(history) == 'Completed' ? WsTypoColors.GREEN : WsTypoColors.YELLOW
                  }
                />
              </Grid>
            </Grid>
            <Grid item xs={12} p={2} container justifyContent="space-between">
              <WsTitleHeader
                title={`${history.requested}`}
                subtitle="Requested"
                reversed={true}
                color={WsTitleColors.BLACK}
              />
              <WsTitleHeader
                title={`${history.processed}`}
                subtitle="Processed"
                reversed={true}
                color={WsTitleColors.BLACK}
              />
              <WsTitleHeader
                title={`${history.valid}`}
                subtitle="Valid"
                reversed={true}
                color={WsTitleColors.BLACK}
              />
              <WsTitleHeader
                title={`${history.invalid}`}
                subtitle="Invalid"
                reversed={true}
                color={WsTitleColors.BLACK}
              />
              <WsTitleHeader
                title={`${history.duplicate}`}
                subtitle="Duplicate"
                reversed={true}
                color={WsTitleColors.BLACK}
              />
              <WsTitleHeader
                title={`${history.validationPending}`}
                subtitle="Pending"
                reversed={true}
                color={WsTitleColors.BLACK}
              />
            </Grid>
          </Card>
        ))
      ) : loader ? (
        <WsListingLoader />
      ) : (
        <NoDataFoundCard text="No History" />
      )}
    </Box>
  );
};
export default ExcelImportHistory;
